import { render, staticRenderFns } from "./HomeworkAddPdfQuestion.vue?vue&type=template&id=51b8c014&scoped=true"
import script from "./HomeworkAddPdfQuestion.vue?vue&type=script&lang=js"
export * from "./HomeworkAddPdfQuestion.vue?vue&type=script&lang=js"
import style0 from "./HomeworkAddPdfQuestion.vue?vue&type=style&index=0&id=51b8c014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b8c014",
  null
  
)

export default component.exports